import { ApiDataAccess } from '../../../infrastructure/ApiDataAccess';
import { PolicyConfirmation } from '../../../dataControls/PolicyConfirmation';
import { Logger } from "../../../infrastructure/Logger";

export class StandardProduct {

    constructor(standardProductId) {
        this.standardProductId = standardProductId;
        this.dataAccess = new ApiDataAccess('/data');
    }

    unpublish() {
        var self = this;
        var url = '/standard-product/' + encodeURIComponent(self.standardProductId) + '/unpublish';

        return new Promise(function (resolve, reject) {
            self.dataAccess.post(url, null)
                .then(data => {
                    resolve(data);                    
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    publish() {
        var self = this;
        return new Promise(function (resolve, reject) {
            self.validatePublishPolicy()
                .then(messages => {
                    PolicyConfirmation.show('Standard Product', messages)
                        .then(confirmed => {
                            if (confirmed === true) {
                                self.executePublish()
                                    .then(data => {
                                        resolve(data);
                                    })
                                    .catch(error => {
                                        Logger.writeError('Error', error);
                                        reject(error);
                                    });
                            }
                            else {
                                resolve();
                            }
                        });
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    validatePublishPolicy() {
        var self = this;
        var url = '/standard-product/' + encodeURIComponent(self.standardProductId) + '/publish?testPolicy=1'

        return new Promise(function (resolve, reject) {
            self.dataAccess.post(url, null)
                .then(data => {
                    if (!data.isSuccess) {
                        reject(data);
                    }
                    resolve(data.messages);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    executePublish() {
        var self = this;
        var url = '/standard-product/' + encodeURIComponent(self.standardProductId) + '/publish';

        return new Promise(function (resolve, reject) {
            self.dataAccess.post(url, null)
                .then(data => {
                    if (!data.isSuccess) {
                        reject(data);
                    }
                    resolve(data.result);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}